import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { getApp } from "../app";
import { doc2Model } from "../api.service";
import { Task } from "../../../../shared/models/task";
import { Subscription } from "rxjs";
import { Post } from "../../../../shared/models/post";
import { Customer } from "../../../../shared/types/customers";

@Component({
    selector: "app-task-panel",
    templateUrl: "./task-panel.component.html",
    styleUrls: ["./task-panel.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TaskPanelComponent implements OnInit {
  @ViewChild("taskCompletedModal", { static: false }) taskCompletedModal: any;
  @ViewChild("discardChangesModal", { static: false }) discardChangesModal: any;
  threadStatus = "";
  columns: string[] = [];

  private _panelSubscription: Subscription = new Subscription();
  private _discardModalSubscription: Subscription = new Subscription();

  app = getApp((app) => {
    this.app = app;
  });

  constructor() {}

  ngOnInit() {
    this.columns = this.app.list.post.taskFieldsList;
    const descriptionIndex = this.columns.indexOf(
      this.app.fieldId.post.taskDescription
    );
    this.columns.splice(descriptionIndex, 1);

    this._panelSubscription = this.app.taskPanel.triggerPanel.subscribe(
      async (value) => {
        if (value) {
          this.app.taskPanel.cleanItem = Object.assign(
            {},
            this.app.taskPanel.selectedItem
          );
          this.app.taskPanel.selectedItemModel = doc2Model(
            "post",
            this.app.taskPanel.selectedItem
          );
          this.threadStatus = this.getThreadStatus(
            this.app.taskPanel.selectedItem
          );
          this.app.taskPanel.creditsSubject.next(
            this.app.taskPanel.selectedItem
          );
          this.app.taskPanel.hasEditPermission(this.app.taskPanel.selectedItem);

          if (this.app.customers.expectCurrent === Customer.KNDS) {
            this.app.taskCompleted.checkOpenTasks(
              this.app.taskPanel.selectedItem as any
            );
          }
        }
      }
    );

    this._discardModalSubscription =
      this.app.taskPanel.openDiscardModal.subscribe(async (value) => {
        if (value && this.discardChangesModal) {
          this.discardChangesModal.open();
        }
      });
  }

  getThreadStatus(post: Task): string {
    if (post == null) {
      return "";
    }
    const snapshot = post.snapshot;
    if (
      snapshot == null ||
      snapshot.thread == null ||
      snapshot.thread.omfStatus == null
    ) {
      return "";
    }
    return this.app.field.getOptionText(
      this.app.fieldId.thread.omfStatus,
      snapshot.thread.omfStatus
    );
  }

  async discardChanges() {
    // Discard changes for the current selected item
    const cleanItemModel = doc2Model("post", this.app.taskPanel.cleanItem);

    this.app.taskPanel.selectedItem.taskDescription =
      this.app.taskPanel.cleanItem.taskDescription;
    this.app.taskPanel.selectedItemModel = cleanItemModel;
    this.app.taskPanel.closePanel();

    // Reroute to a user profile if logged in user decided to discard changes while navigate on a profile
    if (this.app.taskPanel.userProfile !== "") {
      await this.app.routing.navigate(
        this.app.customers.expectCurrent,
        "profile",
        this.app.taskPanel.userProfile
      );
    }
  }

  hasPermissionToClose() {
    let result = false;
    if (
      this.app.taskCompleted.showCompleteTaskIcon(
        this.app.taskPanel.selectedItem as Post
      ) &&
      this.app.taskPanel.checkIfFieldsAreValid()
    ) {
      result = true;
    }
    if (this.app.taskPanel.selectedItem.cannotCloseTask) {
      result = true;
    }
    return result;
  }

  showReopenButton() {
    if (
      this.app.taskCompleted.showReopenTaskIcon(
        this.app.taskPanel.selectedItem as Post
      ) &&
      this.app.taskPanel.checkIfFieldsAreValid()
    ) {
      return true;
    }
    return false;
  }

  async deleteTask() {
    const post = this.app.taskPanel.selectedItem as Post;
    await this.app.post.delete(post);
    this.app.taskPanel.closePanel();
  }

  hasPermissionToAddAttachment() {
    if (this.app.permission.post.addAttachment) {
      return true;
    }

    // User who created the post(comm/sol/task) or task responsible should be able to upload files
    if (
      this.app.taskPanel.selectedItem.create_user_id ===
        this.app.state.userId ||
      this.app.taskPanel.selectedItem.taskResponsible === this.app.state.userId
    ) {
      return true;
    }

    return false;
  }

  ngOnDestroy() {
    this._panelSubscription.unsubscribe();
    this._discardModalSubscription.unsubscribe();
    this.app.taskPanel.userProfile = "";
  }
}
